import React from "react";

export default function PastExperienceContainer(props) {
    return (
        <div className='about-past-experience-container'>
            <h2 className='about-img-list-header'>{props.type}</h2>
            <h2 className='about-img-list-header'>{props.duration}</h2>
            <img className='about-work-experience-image' src={props.src}
                alt={props.alt} />
        </div>
    )
}